import * as Yup from 'yup'

const MerchantInventoryBatchItemRejectSchema = Yup.object().shape({
  reject_reason: Yup.string().required('Required')
})

export default MerchantInventoryBatchItemRejectSchema
